/**
 * STORY#3197 专业版权益详情页 —— 文案与图片资源常量
 *
 * 设计稿：
 *  - H5 ：https://.../oXoRmmtOziyqKnZ3wdEvWZ/...?node-id=13664-1128（375 宽）
 *  - PC ：https://.../oXoRmmtOziyqKnZ3wdEvWZ/...?node-id=13776-804（1918 宽，内容区 1098）
 *
 * 两端**文案完全一致**，差异只在版式与配图尺寸（见本文件注释与 RightsDetail.vue）。
 * 为了便于维护与阅读，本页所有文字、图片都集中在此文件：
 *  - 段落用 `segments` 表达，便于标注「加粗+绿色」的重点片段（设计稿里的 {ts1}**..**{/ts1}）；
 *  - 图片按 `layout` 归类（phone / wide / row4 / row3 / duo / mapPair），由页面按布局渲染。
 */

/* ------------------------------ 图片资源 ------------------------------ */
// 统一在此 require，便于替换与查找；目录 src/assets/images/pro-plan/rights-detail
const IMG = {
  heroVisual: require("@/assets/images/pro-plan/rights-detail/hero-visual-663b15.png"),
  stripDeco: require("@/assets/images/pro-plan/rights-detail/strip-deco.png"),
  // 1 农场 / 2 成员：手机截图（**整张切图**，橙色说明已烧进图内，无需 DOM 叠加）
  farm: require("@/assets/images/pro-plan/rights-detail/benefit-01-farm.png"),
  member: require("@/assets/images/pro-plan/rights-detail/benefit-02-member.png"),
  // 3 合格证：3 张手机截图并排，**各自独立切图**（橙色说明已烧进第 1 张图内）。
  // 圆角由外层 .rd-row3 容器用 CSS 控制（切图本身是完整矩形）
  cert: [
    require("@/assets/images/pro-plan/rights-detail/benefit-03-cert-1.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-03-cert-2.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-03-cert-3.png"),
  ],
  // 4 摄像头：4 张并排
  camera: [
    require("@/assets/images/pro-plan/rights-detail/benefit-04-camera-1.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-04-camera-2.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-04-camera-3.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-04-camera-4.png"),
  ],
  // 5 物联网：8 张（两行各 4 张）
  iot: [
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-1.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-2.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-3.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-4.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-5.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-6.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-7.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-05-iot-8.png"),
  ],
  // 6 企业 LOGO：整张切图（红色标注已烧进图内）。
  // 原先还分 PC / H5 两套（H5 用净图 + DOM 叠加文字），现已统一为 PC 这套
  logo: require("@/assets/images/pro-plan/rights-detail/benefit-06-logo-pc.png"),
  // 7 溯源页：专业版/免费版 对比，**两张独立切图**（红色标注已烧进图内）。
  // 圆角同样由外层 .rd-duo-item 容器控制
  trace: [
    require("@/assets/images/pro-plan/rights-detail/benefit-07-trace-1.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-07-trace-2.png"),
  ],
  // 8 俯瞰图：导出弹窗对比 + 俯瞰图对比（均为整组切图，说明文字已烧进图内）
  // 注：Figma 里 8-1 是「两个弹窗图 + 两个红色说明 TEXT」，8-2 是「俯瞰图对比图 + 角标」。
  // 两者都直接导出**整组**（红色说明/角标随之烧进图），页面不再用 DOM 叠加文字。
  exportDialogs: require("@/assets/images/pro-plan/rights-detail/benefit-08-dialogs.png"),
  exportDialog: require("@/assets/images/pro-plan/rights-detail/benefit-08-map-compare.png"),
  // 9 区块链：两张手机截图
  chain: [
    require("@/assets/images/pro-plan/rights-detail/benefit-09-chain-1.png"),
    require("@/assets/images/pro-plan/rights-detail/benefit-09-chain-2.png"),
  ],
};

export { IMG as RIGHTS_DETAIL_IMG };

/* --------------------------- 页面级装饰（矢量） --------------------------- */
// 顶部深绿背景带：设计稿为「底部带弧线」的矢量形状，两端比例不同
export const RIGHTS_DETAIL_BAND = {
  pc: require("@/assets/images/pro-plan/rights-detail/hero-band-pc.svg"),
  h5: require("@/assets/images/pro-plan/rights-detail/hero-band-h5.svg"),
};
// 卡片右上角绿色渐变装饰（含内部细节，故用设计稿矢量而非 CSS 近似）
export const RIGHTS_DETAIL_CORNER = {
  pc: require("@/assets/images/pro-plan/rights-detail/card-corner-pc.svg"),
  h5: require("@/assets/images/pro-plan/rights-detail/card-corner-h5.svg"),
};
// 首屏标题切图：字体为 Alibaba PuHuiTi 2.0（项目未内置），
// 且带渐变填充 + 文字阴影，CSS 无法还原，故用设计稿切图
export const RIGHTS_DETAIL_TITLE_IMG = {
  pc: require("@/assets/images/pro-plan/rights-detail/hero-title-pc.png"),
  h5: require("@/assets/images/pro-plan/rights-detail/hero-title-h5.png"),
};

/* ------------------------------ 首屏 / 标题条 ------------------------------ */
export const RIGHTS_DETAIL_HERO = {
  title: "专业版9大权益升级",
  // PC 为单行；H5 设计稿为两行（此处按行存放，由页面按端决定是否折行）
  subtitle: "农场随便建，设备连得上，管好生产，溯源更省心",
  subtitleLines: ["农场随便建，设备连得上", "管好生产，溯源更省心"],
  visual: IMG.heroVisual,
  // 卡片内的大号 V 徽章水印（禅道 #23490「缺少背景图标」）：
  // 设计稿节点 2374:297，222×191，纯白 5% 不透明度（SVG 已自带 fill-opacity）
  mark: require("@/assets/images/pro-plan/rights-detail/hero-mark.svg"),
};

export const RIGHTS_DETAIL_STRIP = {
  number: "9",
  text: "项专业版核心权益解释",
  deco: IMG.stripDeco,
};

/* ------------------------------ 重点片段助手 ------------------------------ */
/** 普通片段 */
const t = (text) => ({ text });
/** 加粗 + 绿色（设计稿 ts1） */
const em = (text) => ({ text, strong: true });

/* ------------------------------ 9 大权益正文 ------------------------------ */
/**
 * 每项结构：
 *  - no       序号（用于「1、」前缀）
 *  - title    标题
 *  - blocks   正文块数组，type: "para" | "list"
 *             - para: segments[]，支持 strong 片段
 *             - list: items[].segments[]，支持 strong（绿色）/ label（深色加粗，用于物联网类别名）
 *  - media    配图与版式
 *             - layout: "phone" | "wide" | "row4" | "duo" | "mapPair"
 *             - items[]: { src }
 * 说明：配图一律用**整张切图**——图上的橙色/红色标注都随图导出，
 *       页面不做 DOM 文字叠加（避免定位偏移、文案与切图不同步等问题）。
 */
export const RIGHTS_BENEFITS = [
  {
    no: 1,
    title: "农场数量无限制",
    blocks: [
      {
        type: "para",
        segments: [t("您可以创建任意数量的农场，系统不做限制。")],
      },
    ],
    media: {
      layout: "phone",
      // 整张切图：橙色说明「专业版无数量限制」已烧进图内
      items: [{ src: IMG.farm }],
    },
  },
  {
    no: 2,
    title: "农场成员数量无限制",
    blocks: [
      {
        type: "para",
        segments: [
          t(
            "您可以为每个农场添加任意多名成员（如管理员、农场/生产负责人），各成员可按权限分配任务。适合合作社、农业企业、集团化运营，支持多农场、多角色协同管理。"
          ),
        ],
      },
    ],
    media: {
      layout: "phone",
      // 整张切图：橙色说明「专业版无数量限制」已烧进图内
      items: [{ src: IMG.member }],
    },
  },
  {
    no: 3,
    title: "无限量开具承诺达标合格证",
    blocks: [
      {
        type: "para",
        segments: [
          t(
            "承诺达标合格证是食用农产品追溯的重要凭证。系统支持一键开具合格证、批量开具、关联生产环节溯源信息等功能，可打印或分享给采购方/消费者。"
          ),
        ],
      },
      {
        type: "para",
        segments: [
          t("专业版可解锁"),
          em("合格证无限开具"),
          t(
            "权限，适合规模化生产基地频繁、批量开具合格证，满足日常销售与市场监管要求。"
          ),
        ],
      },
    ],
    media: {
      // 3 张并排，各自独立切图（橙色说明已烧进第 1 张图内，无 DOM 叠加）
      layout: "row3",
      items: IMG.cert.map((src) => ({ src })),
    },
  },
  {
    no: 4,
    title: "接入海康威视、大华摄像头",
    blocks: [
      {
        type: "list",
        items: [
          {
            segments: [
              t("可将您基地已安装的"),
              em("海康威视或大华摄像头"),
              t(
                "，直接接入神农口袋，支持远程实时看场、云端巡田、作业监管，实现可视化无人值守管控，大幅降低人工巡田成本；"
              ),
            ],
          },
          {
            segments: [
              t("系统提供"),
              em("视角收藏夹"),
              t(
                "功能，可保存您常用的摄像头预置位（如特定地块、畜舍、仓库入口等），一键快速切换，无需反复调整角度，尤其适合规模化基地或轮巡场景，节省操作时间；"
              ),
            ],
          },
          {
            segments: [
              t("支持定时"),
              em("抓拍图片"),
              t("功能，对关键画面自动抓拍；抓拍的图片可直接触发"),
              em("AI病虫害识别"),
              t(
                "，系统自动分析图片中的作物当前长势情况，提供关键农事操作建议、识别病虫害风险并给出防范建议，实现早发现、早干预。"
              ),
            ],
          },
        ],
      },
    ],
    media: {
      layout: "row4",
      items: IMG.camera.map((src) => ({ src })),
    },
  },
  {
    no: 5,
    title: "接入物联网环境监测设备",
    blocks: [
      {
        type: "para",
        segments: [
          t("可将您基地已安装的"),
          em("左岸芯慧、新普惠、欧柯奇"),
          t("等厂商的多类型物联网设备接入神农口袋，包括但不限于："),
        ],
      },
      {
        type: "list",
        items: [
          [
            "气象监测类",
            "支持对空气温湿度、风速风向、降雨量、光照强度、大气压力、PM2.5等指标的数据采集。",
          ],
          [
            "土壤监测类",
            "支持对土壤温湿度、电导率（EC值）、pH值、氮磷钾等指标的数据采集。",
          ],
          [
            "虫情监测类",
            "支持对空气温湿度、风速风向、降雨量、光照强度、大气压力、PM2.5等指标的数据采集。",
          ],
          [
            "病情监测类",
            "支持主动捕获孢子、显微成像、数据分析等功能；支持对小麦/玉米/水稻等易发病情进行分析监测。",
          ],
          [
            "水质监测类",
            "支持对溶解氧、浊度、pH、氨氮、余氯、温度等指标的数据采集。",
          ],
          [
            "灌溉首部类",
            "支持对EC、pH、水温、流量及缺肥等状态的监测；支持按设定EC/pH目标值及多种肥料比例自动闭环配肥灌溉。",
          ],
          [
            "阀门和闸门类",
            "支持通过设置阀门/闸门的开合度来实现对水流的精确调节。",
          ],
          [
            "大棚设备类",
            "支持对卷膜器、遮阳网、风机、湿帘、水泵等进行远程控制。",
          ],
          [
            "农情监测类",
            "支持远程可视化观测作物长势，及时发现作物枯黄、倒伏、病虫害、缺苗断垄等问题。",
          ],
        ].map(([label, desc]) => ({
          // 类别名独占一行（.is-label 为 block），说明另起一行 —— 故不再需要前导空格
          // （原先 label 与 desc 同行渲染，靠这个空格分隔；见 RightsDetail.vue 的 .is-label）
          segments: [{ text: label, label: true }, t(desc)],
        })),
      },
    ],
    media: {
      layout: "row4",
      // 8 张分两行（每行 4 张），由页面按 items 数量自动分组
      items: IMG.iot.map((src) => ({ src })),
    },
  },
  {
    no: 6,
    title: "网页版展示企业个性化LOGO",
    blocks: [
      {
        type: "para",
        segments: [
          t(
            "当您访问网页版神农口袋时，工作台/农场地图页面左上角的“神农口袋”官方LOGO可以替换成您的"
          ),
          em("企业LOGO"),
          t(
            "，强化企业品牌形象，尤其是在员工使用或对外展示工作台数据时，提升归属感和专业度。"
          ),
        ],
      },
    ],
    media: {
      // 整张切图（红色标注已烧进图内）。原先 PC/H5 两套配图，现统一为这一张
      layout: "wide",
      pc: { src: IMG.logo },
    },
  },
  {
    no: 7,
    title: "溯源扫码页个性化展示企业信息",
    blocks: [
      {
        type: "para",
        segments: [
          t("消费者扫描溯源二维码打开溯源页面后，可显示您的"),
          em("企业LOGO、产品品牌"),
          t(
            "等个性化信息，而非统一的神农口袋官方样式。每一次扫码都是一次品牌曝光，可增强消费者对您品牌的信任和记忆，提升产品溢价能力。"
          ),
        ],
      },
    ],
    media: {
      // 两张独立切图（红色标注已烧进图内），圆角由 .rd-duo-item 容器控制
      layout: "duo",
      items: IMG.trace.map((src) => ({ src })),
    },
  },
  {
    no: 8,
    title: "农场俯瞰图LOGO/水印自定义",
    blocks: [
      {
        type: "para",
        segments: [
          t("系统支持将卫星地图上的农场地块分布、物联网设备等信息导出为"),
          em("俯瞰图片"),
          t(
            "。在导出时，您可以选择是否在图上叠加自己的企业LOGO，以及是否显示水印和APP下载二维码。"
          ),
        ],
      },
    ],
    media: {
      layout: "mapPair",
      // 8-1：两个「导出信息」弹窗对比（整组切图，红色说明文字已烧进图内，无需 DOM 叠加）
      dialogs: { src: IMG.exportDialogs },
      // 8-2：俯瞰图对比（整组切图，含「专业版 / 免费版」角标）
      mapCompare: { src: IMG.exportDialog },
    },
  },
  {
    no: 9,
    title: "溯源信息上链与区块链展示",
    blocks: [
      {
        type: "para",
        segments: [
          t("专业版开启后，每次生成的溯源信息将同步上传至"),
          em("区块链"),
          t(
            '。消费者扫码时，页面会额外展示"区块链存证"标识、唯一编码、上链时间等信息，利用区块链技术增强溯源信息的公信力，有效防止数据造假，满足高端渠道（如出口、大型商超）对区块链溯源的硬性要求，提升品牌信任度。'
          ),
        ],
      },
    ],
    media: {
      layout: "duo",
      items: IMG.chain.map((src) => ({ src })),
    },
  },
];
